/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { merge } from 'lodash';

import CreateAccount from './CreateAccount';
import HeaderActionComponents from './HeaderActionComponents';
import PayPalForm from './PayPalForm';
import UpdateAccount from './UpdateAccount';

/**
 * The set of components rendered with the Stripe `ConnectView`. These can be
 * extended and replaced using the `components` prop of `ConnectView`.
 *
 * @typedef {Object} StripeConnectViewComponents
 * @property {Function} [Form=ConnectForm] - Renders the form
 * @property {Function} [HeaderActionComponents=HeaderActionComponents] -
 *     Renders the actions in the form header
 * @property {Function} [CreateAccount=CreateAccount] -
 *     Renders the create account action.
 * @property {Function} [UpdateAccount=UpdateAccount] -
 *     Renders the update account action.
 */

export const components = {
  Form: PayPalForm,
  HeaderActionComponents,
  CreateAccount,
  UpdateAccount
};

/**
 * Merges the the custom components passed into the `ConnectView` `components`
 * prop.
 *
 * @param {StripeConnectViewComponents|undefined} [customComponents] -
 *     Custom components passed in as a prop to the
 *
 * @return {StripeConnectViewComponents}
 */
export function mergeDefaultAndCustomComponents(customComponents) {
  return merge({}, components, customComponents);
}
